<template>
  <div class="m-shedule">
    <p class="m-dangqi">
      <span class="m-yudin"><i></i>已预定</span>
      <span><i></i>今日忙</span>
      <span class="m-zuixin m-last"><i></i>最新预定</span>
    </p>
    <div class="m-back"></div>
    <div class="m-shebar">
      <a
        href="javascript:void(0);"
        id="monthStart"
        @click="previous"
        class="m-prevl"
      ></a>
      <span id="monthInfo">{{ thisYear }}年{{ thisMonth }}月</span>
      <a
        href="javascript:void(0);"
        id="monthNext"
        @click="nextMonth"
        class="m-nextr"
      ></a>
    </div>
    <div class="picTable">
      <table id="dateTable">
        <tbody>
          <tr class="m-title">
            <th>日</th>
            <th>一</th>
            <th>二</th>
            <th>三</th>
            <th>四</th>
            <th>五</th>
            <th>六</th>
          </tr>
          <tr>
            <td v-if="index < 7" v-for="(day, index) in schList">
              <span
                :class="{ 'm-yd': day.type === 0, 'm-mang': day.type === 1 }"
                v-show="day.show"
                :id="day.month"
                >{{ day.day }}
                <i
                  v-if="
                    day.type === 0 &&
                    parseInt(day.day) === parseInt(currday) &&
                    parseInt(thisMonth) == parseInt(currmonth) &&
                    thisYear == curryear
                  "
                ></i>
              </span>
              <div
                class="m-buyInfo"
                v-if="day.type == 0"
                :class="{ 'm-buyInfo2': !day.userName }"
              >
                <i></i>
                <p v-if="day.userName">
                  预定人：{{ day.userName.substring(0, 1) }}**
                </p>
                <p v-else>该档期已被预定</p>
                <p v-if="day.serviceName">服务类型：{{ day.serviceName }}</p>
                <p v-if="day.provinceName">
                  {{ day.provinceName }}-{{ day.cityName }}
                </p>
              </div>
            </td>
          </tr>
          <tr>
            <td v-if="index < 14 && index >= 7" v-for="(day, index) in schList">
              <span
                :class="{ 'm-yd': day.type === 0, 'm-mang': day.type === 1 }"
                v-show="day.show"
                :id="day.month"
                >{{ day.day }}
                <i
                  v-if="
                    day.type === 0 &&
                    parseInt(day.day) === parseInt(currday) &&
                    parseInt(thisMonth) == parseInt(currmonth) &&
                    thisYear == curryear
                  "
                ></i>
              </span>
              <div
                class="m-buyInfo"
                v-if="day.type == 0"
                :class="{ 'm-buyInfo2': !day.userName }"
              >
                <i></i>
                <p v-if="day.userName">
                  预定人：{{ day.userName.substring(0, 1) }}**
                </p>
                <p v-else>该档期已被预定</p>
                <p v-if="day.serviceName">服务类型：{{ day.serviceName }}</p>
                <p v-if="day.provinceName">
                  {{ day.provinceName }}-{{ day.cityName }}
                </p>
              </div>
            </td>
          </tr>
          <tr>
            <td
              v-if="index < 21 && index >= 14"
              v-for="(day, index) in schList"
            >
              <span
                :class="{ 'm-yd': day.type === 0, 'm-mang': day.type === 1 }"
                v-show="day.show"
                :id="day.month"
                >{{ day.day }}
                <i
                  v-if="
                    day.type === 0 &&
                    parseInt(day.day) === parseInt(currday) &&
                    parseInt(thisMonth) == parseInt(currmonth) &&
                    thisYear == curryear
                  "
                ></i>
              </span>
              <div
                class="m-buyInfo"
                v-if="day.type == 0"
                :class="{ 'm-buyInfo2': !day.userName }"
              >
                <i></i>
                <p v-if="day.userName">
                  预定人：{{ day.userName.substring(0, 1) }}**
                </p>
                <p v-else>该档期已被预定</p>
                <p v-if="day.serviceName">服务类型：{{ day.serviceName }}</p>
                <p v-if="day.provinceName">
                  {{ day.provinceName }}-{{ day.cityName }}
                </p>
              </div>
            </td>
          </tr>
          <tr>
            <td
              v-if="index < 28 && index >= 21"
              v-for="(day, index) in schList"
            >
              <span
                :class="{ 'm-yd': day.type === 0, 'm-mang': day.type === 1 }"
                v-show="day.show"
                :id="day.month"
                >{{ day.day }}
                <i
                  v-if="
                    day.type === 0 &&
                    parseInt(day.day) === parseInt(currday) &&
                    parseInt(thisMonth) == parseInt(currmonth) &&
                    thisYear == curryear
                  "
                ></i>
              </span>
              <div
                class="m-buyInfo"
                v-if="day.type == 0"
                :class="{ 'm-buyInfo2': !day.userName }"
              >
                <i></i>
                <p v-if="day.userName">
                  预定人：{{ day.userName.substring(0, 1) }}**
                </p>
                <p v-else>该档期已被预定</p>
                <p v-if="day.serviceName">服务类型：{{ day.serviceName }}</p>
                <p v-if="day.provinceName">
                  {{ day.provinceName }}-{{ day.cityName }}
                </p>
              </div>
            </td>
          </tr>
          <tr>
            <td
              v-if="index < 35 && index >= 28"
              v-for="(day, index) in schList"
            >
              <span
                :class="{ 'm-yd': day.type === 0, 'm-mang': day.type === 1 }"
                v-show="day.show"
                :id="day.month"
                >{{ day.day }}
                <i
                  v-if="
                    day.type === 0 &&
                    parseInt(day.day) === parseInt(currday) &&
                    parseInt(thisMonth) == parseInt(currmonth) &&
                    thisYear == curryear
                  "
                ></i>
              </span>
              <div
                class="m-buyInfo"
                v-if="day.type == 0"
                :class="{ 'm-buyInfo2': !day.userName }"
              >
                <i></i>
                <p v-if="day.userName">
                  预定人：{{ day.userName.substring(0, 1) }}**
                </p>
                <p v-else>该档期已被预定</p>
                <p v-if="day.serviceName">服务类型：{{ day.serviceName }}</p>
                <p v-if="day.provinceName">
                  {{ day.provinceName }}-{{ day.cityName }}
                </p>
              </div>
            </td>
          </tr>
          <tr>
            <td
              v-if="index < 42 && index >= 35"
              v-for="(day, index) in schList"
            >
              <span
                :class="{ 'm-yd': day.type === 0, 'm-mang': day.type === 1 }"
                v-show="day.show"
                :id="day.month"
                >{{ day.day }}
                <i
                  v-if="
                    day.type === 0 &&
                    parseInt(day.day) === parseInt(currday) &&
                    parseInt(thisMonth) == parseInt(currmonth) &&
                    thisYear == curryear
                  "
                ></i>
              </span>
              <div
                class="m-buyInfo"
                v-if="day.type == 0"
                :class="{ 'm-buyInfo2': !day.userName }"
              >
                <i></i>
                <p v-if="day.userName">
                  预定人：{{ day.userName.substring(0, 1) }}**
                </p>
                <p v-else>该档期已被预定</p>
                <p v-if="day.serviceName">服务类型：{{ day.serviceName }}</p>
                <p v-if="day.provinceName">
                  {{ day.provinceName }}-{{ day.cityName }}
                </p>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import api from "../../config/api.js";
import dayjs from "dayjs";
export default {
  name: "sche",
  props: ["workerId"],
  data: function () {
    return {
      wid: this.workerId,
      today: new Date(), //当前日期
      thisMonth: new Date().getMonth() + 1,
      thisYear: new Date().getFullYear(),
      stime: "",
      etime: "",
      schList: [],
      scheduleList: [],
      newtime: "",
      currday: "",
      currmonth: "",
      curryear: "",
    };
  },
  created: function () {
    let vm = this;
    for (let i = 0; i < 42; i++) {
      let weekData = {
        show: false,
        type: -1,
        month: 0,
        day: 0,
      };
      vm.schList.push(weekData);
    }
    vm.getNewSche();
  },
  methods: {
    filterStr: function () {},
    getSche: function () {
      let vm = this;
      vm.stime = vm.thisYear + "-" + vm.thisMonth + "-01";
      vm.etime = vm.thisYear + "-" + vm.thisMonth + "-31";
      let url = api.API_URL + "worker/v1/query/schedule/map";
      vm.getNewAjax(
        url,
        { workerId: vm.wid, stime: vm.stime, etime: vm.etime },
        function (result) {
          //得到所有数据
          vm.scheduleList = result;
          for (let key in vm.scheduleList) {
            let thisSchDay = key; //婚期日
            let mapValue = vm.scheduleList[key];
            for (let j = 0; j < vm.schList.length; j++) {
              if (vm.schList[j].show) {
                let day = vm.schList[j].day;
                let month = vm.schList[j].month;
                if (day < 10) {
                  day = "0" + day;
                }
                if (thisSchDay === vm.thisYear + "-" + month + "-" + day) {
                  if (mapValue[0].type === "WORKING") {
                    vm.schList[j].type = 0;
                    vm.schList[j].userName = mapValue[0].userName;
                    vm.schList[j].provinceName = mapValue[0].provinceName;
                    vm.schList[j].cityName = mapValue[0].cityName;
                    if (mapValue[0].serviceName) {
                      vm.schList[j].serviceName = mapValue[0].serviceName;
                    }
                  }
                  if (mapValue[0].type === "REST") {
                    vm.schList[j].type = 1;
                  }
                  if (mapValue[0].type === "SYSTEMREST") {
                    vm.schList[j].type = 1;
                  }
                  break;
                }
              }
            }
          }
        },
        function (result) {},
        function () {}
      );
    },
    getNewSche: function () {
      let vm = this;
      let url = api.API_URL + "worker/v1/query/new/schedule";
      vm.getNewAjax(
        url,
        { workerId: vm.wid },
        function (result) {
          //得到所有数据
          if (result) {
            vm.newtime = result;
            //判断是不是大于当前日期 是的话 跳到新的日期 否则就当前月份
            vm.curryear = vm.newtime.substring(0, 4);
            vm.currmonth = vm.newtime.substring(5, 7);
            if (
              vm.curryear > vm.thisYear ||
              (vm.curryear == vm.thisYear &&
                parseInt(vm.currmonth) >= parseInt(vm.thisMonth))
            ) {
              vm.thisMonth = vm.currmonth;
              vm.thisYear = vm.curryear;
              vm.currday = vm.newtime.substring(8, 10);
            } else {
              vm.thisMonth = new Date().getMonth() + 1;
              vm.thisYear = new Date().getFullYear();
              vm.currday = "";
            }
          } else {
            vm.thisMonth = new Date().getMonth() + 1;
            vm.thisYear = new Date().getFullYear();
            vm.newtime = "";
            vm.currday = "";
          }

          vm.viewSchedule();
        },
        function (result) {
          vm.errorOper();
        },
        function () {
          vm.errorOper();
        }
      );
    },
    errorOper: function () {
      let vm = this;
      vm.thisMonth = new Date().getMonth() + 1;
      vm.thisYear = new Date().getFullYear();
      vm.viewSchedule();
    },
    //上一个月
    previous: function () {
      let vm = this;
      var thisM = parseInt(vm.thisMonth);
      var thisY = parseInt(vm.thisYear);
      if (thisM == 1) {
        thisM = 12;
        thisY = thisY - 1;
      } else {
        thisM = thisM - 1;
      }
      vm.thisYear = thisY;
      vm.thisMonth = thisM;
      vm.viewSchedule();
    },
    //下一个月
    nextMonth: function () {
      let vm = this;
      var thisM = parseInt(vm.thisMonth);
      var thisY = parseInt(vm.thisYear);
      if (thisM == 12) {
        thisM = 1;
        thisY = thisY + 1;
      } else {
        thisM = thisM + 1;
      }
      vm.thisYear = thisY;
      vm.thisMonth = thisM;
      vm.viewSchedule();
    },
    formateData: function (ctime, type) {
      return dayjs(new Date(ctime)).format(type);
    },
    viewSchedule: function () {
      let vm = this;
      //重置
      for (let i = 0; i < 42; i++) {
        vm.schList[i].show = false;
        vm.schList[i].type = -1;
      }
      vm.thisMonth = parseInt(vm.thisMonth);
      if (vm.thisMonth && vm.thisMonth < 10) {
        vm.thisMonth = "0" + vm.thisMonth;
      }
      vm.today = new Date(vm.thisYear + "-" + vm.thisMonth + "-01");
      let cuday = vm.today.getDay(); //获取该月第一天是星期几 0-6,0代表星期天 设置日期表格
      //获取上一个月有多少天
      let exDayNum = vm.monthDay(vm.thisYear, parseInt(vm.thisMonth));
      for (let k = 0; k < exDayNum; k++, cuday++) {
        vm.schList[cuday].show = true;
        vm.schList[cuday].monthnpm = vm.thisMonth;
        vm.schList[cuday].month = vm.thisMonth;
        vm.schList[cuday].day = k + 1;
      }
      //加载档期
      vm.getSche();
    },
    //是否为闰年
    isLeapYear: function (year) {
      if (year % 4 == 0 && year % 100 != 0) {
        return true;
      } else {
        if (year % 400 == 0) {
          return true;
        } else {
          return false;
        }
      }
    },
    //判断每月有几天
    monthDay: function (year, month) {
      let vm = this;
      if (
        month == 1 ||
        month == 3 ||
        month == 5 ||
        month == 7 ||
        month == 8 ||
        month == 10 ||
        month == 12 ||
        month == 0
      ) {
        return 31;
      } else if (month == 4 || month == 6 || month == 9 || month == 11) {
        return 30;
      } else if (month == 2 && vm.isLeapYear(year)) {
        return 29;
      } else {
        return 28;
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// _worker_sche.vue?78150a02